(() => {
  const ROOT_ID = 'gigi-whatsapp-widget';
  const WHATSAPP_URL = 'https://wa.me/50672309213?text=Hola%20GIGI%2C%20estoy%20en%20la%20tienda%20en%20l%C3%ADnea%20y%20necesito%20ayuda%20con%20mi%20compra.';

  function whatsappIcon() {
    return `
      <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false">
        <path d="M16 4.2c-6.3 0-11.4 5-11.4 11.2 0 2.2.7 4.3 1.8 6.1L4.5 27.8l6.5-1.7c1.6.9 3.3 1.3 5 1.3 6.3 0 11.4-5 11.4-11.2S22.3 4.2 16 4.2Z"></path>
        <path d="M11.5 10.4c.3-.7.6-.7 1-.7h.8c.2 0 .5.1.7.6l1 2.4c.1.4.1.7-.1 1l-.8 1c-.2.2-.3.4-.1.7.8 1.4 2 2.6 3.5 3.4.3.2.5.1.7-.1l1-1.2c.3-.3.6-.4.9-.2l2.3 1.1c.4.2.6.4.6.7 0 .4-.2 1.7-1 2.5-.9.9-2.2 1.3-3.6 1-1.4-.3-3.2-1-5.2-2.7-2.4-2-4-4.6-4.5-6.2-.4-1.4 0-2.5.8-3.3Z"></path>
      </svg>`;
  }

  function removeShopifyChat() {
    document.querySelectorAll('#chat-drawer, shopify-chat').forEach((element) => element.remove());
  }

  function install() {
    removeShopifyChat();
    if (document.getElementById(ROOT_ID)) return;

    const root = document.createElement('div');
    root.id = ROOT_ID;
    root.className = 'gigi-whatsapp';
    root.innerHTML = `
      <div class="gigi-whatsapp__panel" id="gigi-whatsapp-panel" hidden>
        <button class="gigi-whatsapp__close" type="button" aria-label="Cerrar WhatsApp">×</button>
        <div class="gigi-whatsapp__mini-icon" aria-hidden="true">${whatsappIcon()}</div>
        <p class="gigi-whatsapp__eyebrow">GIGI POR WHATSAPP</p>
        <p class="gigi-whatsapp__title">¡Hola! ¿Cómo podemos ayudarte hoy?</p>
        <p class="gigi-whatsapp__copy">Escríbenos y te acompañamos personalmente con tallas, disponibilidad o tu compra.</p>
        <a class="gigi-whatsapp__start" href="${WHATSAPP_URL}" target="_blank" rel="noopener noreferrer">
          <span aria-hidden="true">${whatsappIcon()}</span>
          <strong>Iniciar conversación</strong>
          <span aria-hidden="true">→</span>
        </a>
      </div>
      <button class="gigi-whatsapp__fab" type="button" aria-label="Hablar con GIGI por WhatsApp" aria-controls="gigi-whatsapp-panel" aria-expanded="false">
        ${whatsappIcon()}
      </button>`;

    document.body.appendChild(root);

    const panel = root.querySelector('.gigi-whatsapp__panel');
    const fab = root.querySelector('.gigi-whatsapp__fab');
    const close = root.querySelector('.gigi-whatsapp__close');

    function setOpen(open) {
      panel.hidden = !open;
      fab.setAttribute('aria-expanded', String(open));
      root.classList.toggle('is-open', open);
    }

    fab.addEventListener('click', () => setOpen(panel.hidden));
    close.addEventListener('click', () => setOpen(false));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) setOpen(false);
    });

    document.addEventListener('click', (event) => {
      if (!panel.hidden && !root.contains(event.target)) setOpen(false);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  else install();

  window.addEventListener('pageshow', install);
})();
